 setInterval(function time(){
    var d = new Date();
    var hours = 23 - d.getHours();
    if(hours < 10) {
      hours = '0' + hours;
    }
    var min = 59 - d.getMinutes();
    if(min < 10) {
      min = '0' + min;
    }
    var sec = 59 - d.getSeconds();
    if(sec < 10) {
      sec = '0' + sec;
    }
    let time = document.getElementsByClassName('aus_timerr');
    for(let i = 0; i < time.length; i++) {
      time[i].innerHTML = `00:${hours}:${min}:${sec}`;
    }
  }, 1000);